export default __webpack_public_path__ + "static/media/055-online-payment-1.3eebbdf9.svg";